import { Avatar, Tooltip } from "@fluentui/react-components";
import React from "react";

import { MemberRaw } from "../../domain/Member";
import { getPersonaImageProps } from "../AccountPersona";

import styles from "./index.module.css";

const maxNumbers = 3;
/**
 * @description 同じドキュメントにアクセスしている人数分だけアイコンを出す
 */
export const SessionsFacepile: React.FC<{
  accessMembersRaw: MemberRaw[];
}> = ({ accessMembersRaw = [] }) => {
  const membersRaw = accessMembersRaw.slice(0, maxNumbers);
  const overflowMembersRaw = accessMembersRaw.slice(maxNumbers);

  return (
    <div className={styles.container}>
      <div className={styles.facepile}>
        {membersRaw.map((member) => (
          <Tooltip
            key={member.uid}
            withArrow
            content={
              <div>
                <div>{member.display_name}</div>
                <div>{member.email}</div>
              </div>
            }
            relationship="label"
          >
            <Avatar
              name={member.display_name}
              size={32}
              className={styles.avatarItem}
              {...getPersonaImageProps(member)}
            />
          </Tooltip>
        ))}
        {overflowMembersRaw.length > 0 && (
          <Tooltip
            withArrow
            content={
              <div>
                {overflowMembersRaw.map((member) => (
                  <div
                    key={member.uid}
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      marginBottom: "4px",
                    }}
                  >
                    <Avatar
                      name={member.display_name}
                      size={24}
                      {...getPersonaImageProps(member)}
                    />
                    <span>{member.display_name}</span>
                  </div>
                ))}
              </div>
            }
            relationship="label"
          >
            <Avatar
              size={32}
              className={styles.avatarItem}
              initials={{ children: `+${overflowMembersRaw.length}` }}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};
